const REBOOT_PENDING_KEY = "headsetRebootPending";

export const HEADSET_REBOOT_PENDING_TTL_MS = 5 * 60 * 1000;

type PendingHeadsetReboot = { pid: string; requestedAt: number };

function readPendingHeadsetReboot(): PendingHeadsetReboot | null {
  try {
    const raw = localStorage.getItem(REBOOT_PENDING_KEY);
    if (!raw) return null;
    const { pid, requestedAt } = JSON.parse(raw) as Partial<PendingHeadsetReboot>;
    if (typeof pid !== "string" || typeof requestedAt !== "number") return null;
    return { pid, requestedAt };
  } catch {
    return null;
  }
}

export function markHeadsetRebootPending(pid: string): void {
  try {
    localStorage.setItem(REBOOT_PENDING_KEY, JSON.stringify({ pid, requestedAt: Date.now() }));
  } catch (error) {
    console.error("Failed to store the pending headset reboot:", error);
  }
}

export function clearHeadsetRebootPending(): void {
  try {
    localStorage.removeItem(REBOOT_PENDING_KEY);
  } catch (error) {
    console.error("Failed to clear the pending headset reboot:", error);
  }
}

export function resolvePolledScene(
  pid: string | null | undefined,
  scene: string | null | undefined,
): string | null {
  const reportedScene = scene ?? null;
  const pending = readPendingHeadsetReboot();
  if (!pending || !pid || pending.pid !== pid) return reportedScene;

  const isExpired = Date.now() - pending.requestedAt > HEADSET_REBOOT_PENDING_TTL_MS;
  const isBusyScene = Boolean(reportedScene) && reportedScene !== "Menu";
  if (isExpired || !isBusyScene) {
    clearHeadsetRebootPending();
    return reportedScene;
  }
  return null;
}
